module.exports = __webpack_public_path__ + "media/images/icons/country_flags/lv-ff6176a6bfeba64d07169ecd7c2162a2.svg";